import React from "react";
import { useTranslation } from "react-i18next";
import { metrikaGoal } from "../analytics/metrika";

const FOOTER_GOALS: Record<string, string> = {
    'Игры': 'nav_games_click',
    'Друзья': 'nav_friends_click',
    'Задания': 'nav_tasks_click',
    'Профиль': 'nav_profile_click',
    'Ещё': 'nav_more_click',
};

function FooterItem(props: any) {
    const { t } = useTranslation();

    const handleClick = () => {
        const goal = FOOTER_GOALS[props.name];

        if (goal) {
            metrikaGoal(goal);
        }

        // сохраняем текущую логику
        if (props.func) {
            props.func();
        }
    };

    return (
        <div className="footer-item" onClick={handleClick}>
            {props.activeIconName === props.name ? (
                <img src={props.selectedIcon} alt="icon" width="30" height="30" />
            ) : (
                <img src={props.defaultIcon} alt="icon" width="30" height="30" />
            )}

            <div
                className={
                    props.activeIconName !== props.name
                        ? "footer-item_name"
                        : "footer-item_name is-active"
                }
            >
                {t(props.name)}
            </div>
        </div>
    );
}

export default FooterItem;
